import { useModalState } from "@clipboard-health/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useEffect } from "react";

import { useGetLicensesCount } from "../api/useGetLicensesCount";
import { AddLicenseAlertBottomSheet } from "./AddLicenseAlertBottomSheet";
import { PendingLicenseAlertBottomSheet } from "./PendingLicenseAlertBottomSheet";

/**
 * @deprecated Remove when surface shifts is fully rolled out
 */
export function LicenseAlertBottomSheet() {
  const worker = useDefinedWorker();

  const addLicenseModalState = useModalState();
  const pendingLicenseModalState = useModalState();

  const { setModalStatus: setAddLicenseModalStatus } = addLicenseModalState;
  const { setModalStatus: setPendingLicenseModalStatus } = pendingLicenseModalState;

  const { data: licensesCount, isSuccess } = useGetLicensesCount({
    workerId: worker.userId,
  });

  useEffect(() => {
    if (
      isSuccess &&
      (!licensesCount?.ACTIVE || licensesCount.ACTIVE <= 0) &&
      (!licensesCount?.EXPIRING || licensesCount.EXPIRING <= 0)
    ) {
      if (!licensesCount?.PENDING || licensesCount.PENDING <= 0) {
        setAddLicenseModalStatus("open");
        setPendingLicenseModalStatus("closed");
      } else {
        setAddLicenseModalStatus("closed");
        setPendingLicenseModalStatus("open");
      }
    }
  }, [isSuccess, licensesCount, setAddLicenseModalStatus, setPendingLicenseModalStatus]);

  return (
    <>
      <AddLicenseAlertBottomSheet modalState={addLicenseModalState} />
      <PendingLicenseAlertBottomSheet modalState={pendingLicenseModalState} />
    </>
  );
}
